export default __webpack_public_path__ + "static/1_month-0c3997285a66b01ebf96c176c4020c26.jpeg";